import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

type MutationPayload = { phone: string };

type MutationResponse = {
  status: number;
  data: { success: boolean; phone: string };
};

export const useExpireConversationWindowMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while expiring the conversation window',
    endpoint: ({ phone }) => `/api/admin/whatsapp/window/${encodeURIComponent(phone)}`,
    method: 'DELETE',
  });

  return useMutation<MutationResponse, Error, MutationPayload>({ mutationFn });
};
